/******/ (function() { // webpackBootstrap
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @file ShippingBlockManager.js
 * @description Manages shipping block functionality.
 */

/** Narvar delimits emphasised copy with a pair of `&hairsp;` characters, parsed to U+200A. */
var HAIR_SPACE = "\u200A";

/**
 * Helper class for DOM operations.
 */
var DOMHelper = /*#__PURE__*/function () {
  function DOMHelper() {
    _classCallCheck(this, DOMHelper);
  }
  return _createClass(DOMHelper, null, [{
    key: "getElement",
    value:
    /**
     * Retrieves a single element from the DOM.
     * @param {string} selector - The CSS selector for the element.
     * @returns {Element} The found DOM element.
     * @throws {Error} If the element is not found.
     */
    function getElement(selector) {
      var element = document.querySelector(selector);
      if (!element) {
        console.log("Element not found: ".concat(selector));
      }
      return element;
    }

    /**
     * Retrieves multiple elements from the DOM.
     * @param {string} selector - The CSS selector for the elements.
     * @returns {NodeList} The found DOM elements.
     * @throws {Error} If no elements are found.
     */
  }, {
    key: "getElements",
    value: function getElements(selector) {
      var elements = document.querySelectorAll(selector);
      if (elements.length === 0) {
        console.log("No elements found: ".concat(selector));
      }
      return elements;
    }

    /**
     * Toggles multiple classes on an element.
     * @param {Element} element - The DOM element to modify.
     * @param {...string} classNames - The class names to toggle.
     */
  }, {
    key: "toggleClasses",
    value: function toggleClasses(element) {
      for (var _len = arguments.length, classNames = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        classNames[_key - 1] = arguments[_key];
      }
      classNames.forEach(function (className) {
        return element.classList.toggle(className);
      });
    }
  }]);
}();
/**
 * Manages the shipping block functionality.
 */
var ShippingBlockManager = /*#__PURE__*/function () {
  /**
   * Initializes the ShippingBlockManager.
   * @throws {Error} If required DOM elements are not found.
   */
  function ShippingBlockManager() {
    _classCallCheck(this, ShippingBlockManager);
    // Cache DOM elements
    this.waitForNarvarPromiseCalculator();
    this.shippingBlocks = DOMHelper.getElements('.shipping-block');
    this.shippingBlockContainer = DOMHelper.getElement('.shipping-blocks');
    this.shippingSelector = DOMHelper.getElement('.shipping-selector');
    this.shippingSelectorHeader = DOMHelper.getElement('.shipping-selector__header');
    this.closeButton = DOMHelper.getElement('[js-close-shipping-selector]');
    this.closeIcons = DOMHelper.getElements('[js-close-shipping-selector] .icon');
    try {
      this.initializeShippingBlocks();
      this.addEventListeners();
    } catch (error) {
      console.log('Error initializing ShippingBlockManager:', error.message);
    }
  }
  return _createClass(ShippingBlockManager, [{
    key: "waitForNarvarPromiseCalculator",
    value: function waitForNarvarPromiseCalculator() {
      var _this = this;
      var waitForNarvarPromiseCalculator = setInterval(function () {
        var narvarPromiseCalculator = document.querySelector('#narvar-promise-calculator');
        if (narvarPromiseCalculator) {
          clearInterval(waitForNarvarPromiseCalculator);
          _this.initNarvarFormPopUp();
          _this.initNarvarMessageFormatter();
        }
      }, 100);
    }
  }, {
    key: "initNarvarFormPopUp",
    value: function initNarvarFormPopUp() {
      var narvarPromiseCalculator = document.querySelector('#narvar-promise-calculator');
      if (!narvarPromiseCalculator) return;
      var firstButtonAsDirectChildOfForm = narvarPromiseCalculator.querySelector('button');
      var createFormHeading = function createFormHeading() {
        var container = document.createElement('div');
        container.className = 'heading-container';
        var title = document.createElement('h4');
        title.className = 'heading-title';
        title.textContent = 'Edit ZIP Code';
        var copy;
        if (window.innerWidth > 991) {
          copy = document.createElement('p');
          copy.className = 'heading-copy';
          copy.textContent = 'Enter a ZIP Code to see when it will arrive';
        }
        var button = document.createElement('button');
        ['heading-close', 'button', 'button--icon', 'button-close'].forEach(function (className) {
          return button.classList.add(className);
        });
        button.setAttribute('js-close-shipping-selector', '');
        button.setAttribute('aria-label', 'Close');
        /* Set button type to button */
        button.type = 'button';
        button.innerHTML = "\n        <svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"icon icon-close\">\n          <rect x=\"4.88281\" y=\"3.95703\" width=\"12.7059\" height=\"1.05882\" rx=\"0.529412\" transform=\"rotate(45 4.88281 3.95703)\" fill=\"white\"/>\n          <rect x=\"4.13379\" y=\"12.9412\" width=\"12.7059\" height=\"1.05882\" rx=\"0.529412\" transform=\"rotate(-45 4.13379 12.9412)\" fill=\"white\"/>\n        </svg>\n      ";
        if (window.innerWidth > 991) {
          container.append(title, copy, button);
        } else {
          container.append(title, button);
        }
        return container;
      };
      var addPTagToForm = function addPTagToForm(form) {
        var p = document.createElement('p');
        p.className = 'narvar-promise-form-copy';
        p.textContent = 'Enter a ZIP Code to see when it will arrive';
        form.querySelector('.shipping-block__form').prepend(p);
      };
      var handleFormAdded = function handleFormAdded(form) {
        var firstDiv = form.querySelector('div:first-child');
        if (!firstDiv) return;
        firstDiv.classList.add('shipping-block__form');
        firstDiv.classList.add('shipping-block__form--open');
        form.prepend(createFormHeading());
        if (window.innerWidth < 991) {
          document.body.classList.add('shipping-block__form--open');
          addPTagToForm(form);
        }
        updateButtonLabel(form);
        closeButtonEventListener(form);
      };
      var closeButtonEventListener = function closeButtonEventListener(form) {
        var closeButton = form.querySelector('[js-close-shipping-selector]');
        if (!closeButton) return;
        closeButton.addEventListener('click', function () {
          document.body.classList.remove('shipping-block__form--open');
          firstButtonAsDirectChildOfForm.click();
        });
      };
      var updateButtonLabel = function updateButtonLabel(form) {
        var button = form.querySelector('.narvar-promise-postal-input');
        if (!button) return;
        button.textContent = 'Apply';
      };
      var observer = new MutationObserver(function (mutations) {
        var _iterator = _createForOfIteratorHelper(mutations),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var mutation = _step.value;
            if (mutation.type !== 'childList' || !mutation.addedNodes.length && !mutation.removedNodes.length) continue;
            var specificAddedNode = mutation.addedNodes[0];
            var nodeType = specificAddedNode === null || specificAddedNode === void 0 ? void 0 : specificAddedNode.nodeType;
            var specificRemovedNode = mutation.removedNodes[0];
            var removedNodeType = specificRemovedNode === null || specificRemovedNode === void 0 ? void 0 : specificRemovedNode.nodeType;
            if (specificAddedNode && nodeType !== 1 || specificRemovedNode && removedNodeType !== 1) break;
            var form = specificAddedNode === null || specificAddedNode === void 0 ? void 0 : specificAddedNode.querySelector('form');
            if (form) {
              handleFormAdded(form);
              break;
            } else if (specificRemovedNode && removedNodeType === 1 && window.innerWidth < 991) {
              document.body.classList.remove('shipping-block__form--open');
              break;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
      observer.observe(narvarPromiseCalculator, {
        childList: true,
        subtree: true
      });
    }

    /**
     * Keeps the EDD message formatted as Narvar re-renders it.
     * The widget re-renders on ZIP and variant changes, so this re-runs on every mutation.
     * No disconnect is needed: each pass consumes the markers it acts on, so the pass
     * triggered by our own writes finds nothing left to do and the cascade stops.
     */
  }, {
    key: "initNarvarMessageFormatter",
    value: function initNarvarMessageFormatter() {
      var root = document.querySelector('#narvar-promise-calculator');
      if (!root) return;
      var format = function format() {
        return ShippingBlockManager.boldHairSpacePairs(root);
      };
      format();
      new MutationObserver(format).observe(root, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }

    /**
     * Wraps each hair-space-delimited run of text in a <b> tag.
     * "Delivered by &hairsp;Sat, Aug 1&hairsp;." becomes "Delivered by <b>Sat, Aug 1</b>."
     * An unpaired trailing marker is left alone, which keeps the pass idempotent.
     * @param {Element} root - The element to search within.
     */
  }, {
    key: "initializeShippingBlocks",
    value:
    /**
     * Initializes each shipping block.
     */
    function initializeShippingBlocks() {
      var _this2 = this;
      var lengthBlocks = this.shippingBlocks.length;
      this.shippingBlocks.forEach(function (block, index) {
        return _this2.waitForInput(block, index, lengthBlocks);
      });
    }

    /**
     * Waits for an input element to be added to a shipping block.
     * @param {Element} block - The shipping block element.
     */
  }, {
    key: "waitForInput",
    value: function waitForInput(block) {
      var _this3 = this;
      // Use MutationObserver to watch for changes in the block
      var interval = setInterval(function () {
        if (block.querySelector('input')) {
          var input = block.querySelector('input');
          if (input) {
            input.addEventListener('change', function () {
              return _this3.toggleShippingBlock(block);
            });
          }
          clearInterval(interval);
        }
      }, 100);
    }

    /**
     * Adds event listeners to interactive elements.
     */
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this4 = this;
      // this.closeButton.addEventListener('click', () => this.toggleShippingBlockContainer());
      this.shippingSelectorHeader.addEventListener('click', function (e) {
        return _this4.toggleShippingBlockContainer(e);
      });
      this.shippingBlocks.forEach(function (block) {
        return block.addEventListener('click', function () {
          return _this4.toggleShippingBlock(block);
        });
      });
    }

    /**
     * Toggles the visibility of the shipping block container and related elements.
     * @param {Event} e - The event object
     */
  }, {
    key: "toggleShippingBlockContainer",
    value: function toggleShippingBlockContainer(e) {
      e.preventDefault();
      var narvarCalculator = e.target.closest('#narvar-promise-calculator');
      if (!narvarCalculator) return;
      if (this.isSVGElement(e.target)) {
        this.handleSVGClick(e, narvarCalculator);
      } else if (e.target.tagName === 'BUTTON') {
        this.handleButtonClick(narvarCalculator);
      }
      this.toggleCloseIcons();
    }

    /**
     * Checks if the target element is an SVG or SVG child
     * @param {Element} target - The event target
     * @returns {boolean}
     */
  }, {
    key: "isSVGElement",
    value: function isSVGElement(target) {
      return target.tagName === 'svg' || target.ownerSVGElement;
    }

    /**
     * Handles click events on SVG elements
     * @param {Event} e - The event object
     * @param {Element} calculator - The narvar calculator element
     */
  }, {
    key: "handleSVGClick",
    value: function handleSVGClick(e, calculator) {
      e.stopPropagation();
      e.stopImmediatePropagation();
      var divElements = Array.from(calculator.children).filter(function (child) {
        return child.tagName === 'DIV' && !child.querySelector('form');
      });
      divElements.forEach(function (div) {
        return div.classList.toggle('open');
      });
      e.target.closest('svg').classList.toggle('ACTIVE');
    }

    /**
     * Handles click events on button elements
     * @param {Element} calculator - The narvar calculator element
     */
  }, {
    key: "handleButtonClick",
    value: function handleButtonClick(calculator) {
      var form = calculator.querySelector('form');
      if (form) {
        form.classList.remove('hidden');
      }
    }

    /**
     * Toggles visibility of close icons
     */
  }, {
    key: "toggleCloseIcons",
    value: function toggleCloseIcons() {
      this.closeIcons.forEach(function (icon) {
        return DOMHelper.toggleClasses(icon, 'hidden');
      });
    }

    /**
     * Toggles the active state of a shipping block.
     * @param {Element} activeBlock - The block to be activated.
     */
  }, {
    key: "toggleShippingBlock",
    value: function toggleShippingBlock(activeBlock) {
      this.shippingBlocks.forEach(function (block) {
        block.classList.toggle('shipping-block--active', block === activeBlock);
        if (block === activeBlock) {
          var input = block.querySelector('input');
          if (input && !input.checked) {
            input.checked = true;
          }
        }
      });
    }
  }], [{
    key: "boldHairSpacePairs",
    value: function boldHairSpacePairs(root) {
      // Each iteration removes exactly two markers, so this always makes progress.
      // The cap is only a backstop against a malformed DOM.
      for (var pass = 0; pass < 20; pass += 1) {
        var markers = ShippingBlockManager.findHairSpaces(root, 2);
        if (markers.length < 2) return;
        var _markers = _slicedToArray(markers, 2),
          start = _markers[0],
          end = _markers[1];
        var sameNode = start.node === end.node;

        // Delete the later marker first so the earlier offset stays valid.
        end.node.deleteData(end.offset, 1);
        start.node.deleteData(start.offset, 1);
        var range = document.createRange();
        range.setStart(start.node, start.offset);
        range.setEnd(end.node, sameNode ? end.offset - 1 : end.offset);

        // extractContents/insertNode rather than surroundContents, which throws when
        // the pair spans an element boundary instead of sitting in one text node.
        var bold = document.createElement('b');
        bold.appendChild(range.extractContents());
        range.insertNode(bold);
      }
    }

    /**
     * Finds hair space characters in document order across all text nodes under an element.
     * @param {Element} root - The element to search within.
     * @param {number} limit - Stop once this many have been found.
     * @returns {Array<{node: Text, offset: number}>} The located markers.
     */
  }, {
    key: "findHairSpaces",
    value: function findHairSpaces(root, limit) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      var found = [];
      for (var node = walker.nextNode(); node; node = walker.nextNode()) {
        var offset = node.nodeValue.indexOf(HAIR_SPACE);
        while (offset !== -1) {
          found.push({
            node: node,
            offset: offset
          });
          if (found.length === limit) return found;
          offset = node.nodeValue.indexOf(HAIR_SPACE, offset + 1);
        }
      }
      return found;
    }
  }]);
}(); // Initialize the ShippingBlockManager when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
  try {
    new ShippingBlockManager();
  } catch (error) {
    console.log('Error initializing ShippingBlockManager:', error.message);
  }
});
/******/ })()
;